
let setImages = (state, { payload }) => {
    state.images = payload;
}

export default setImages;